import styled from "styled-components";

export const Wrapper = styled.div`
width: 317px;
height: 212px;
background-size: cover;
margin: 10px;
margin-right: 20px;
cursor: pointer;
`;

export const CorporateCardAppartmentText = styled.div`
    width: 100%;
    font-family: "Robotto";
    height: 50px;
    background-color: rgba(46,15,89,0.6);
    font-weight: 700;
    font-size: 25px;
    color: white;
    margin: 147px auto auto auto;
    text-align: center;
    padding-top: 15px;
`;